import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import Header from './Header';
import ItemListPicker from './ItemListPicker';

const useStyles = buildUseStyles('MainContent', () => ({
  root: {
    width: '100%',
  },
}));

const MainContent = ({ mainContentSubHeader, itemListMetaOverride }) => {
  const classes = useStyles();

  return (
    <Box
      className={classes.root}
    >
      <Header />
      {mainContentSubHeader && mainContentSubHeader}
      <ItemListPicker metaOverrideSet={itemListMetaOverride} />
    </Box>
  );
};

MainContent.propTypes = {
  mainContentSubHeader: PropTypes.node,
  itemListMetaOverride: PropTypes.object,
};

MainContent.defaultProps = {
  mainContentSubHeader: null,
  itemListMetaOverride: null,
};

export default MainContent;
